export const SEARCH_SYNONYMS: Record<string, string> = {
  // Rosé
  'rose': 'rose wine',
  'rosato': 'rose wine',
  'pink': 'rose wine',
  'blush-rose': 'rose wine',
  'rose wine': 'rose wine',

  // Red wine
  'red': 'red wine',
  'red-wine': 'red wine',
  'rosso wine': 'red wine',
  'wine red': 'red wine',
  'wine/red': 'red wine',
  'red wine': 'red wine',

  // White wine
  'white': 'white wine',
  'white wine': 'white wine',
  'wine white': 'white wine',
  'wine bianco': 'white wine',
  'wine blanc': 'white wine',
  'blanc wine': 'white wine',

  // Sparkling
  'sparkling wine': 'sparkling wine',
  'sparkling white wine': 'sparkling wine',
  'sparkling-wine': 'sparkling wine',
  'bubbly wine': 'sparkling wine',
  'mimosa': 'sparkling wine',

  // Pinot Grigio
  'pinot gris': 'pinot grigio',
  'pinot-grigio': 'pinot grigio',
  'pinot grigio': 'pinot grigio',

  // Pinot Noir
  'pinot noir': 'pinot noir',
  'pinot-noir': 'pinot noir',

  // Sauvignon
  'cabernet': 'cabernet sauvignon',
  'cabernet-sauvignon': 'cabernet sauvignon',
  'sauvignon': 'cabernet sauvignon',

  // Sauvignon Blanc
  'sauvignon blanc': 'sauvignon blanc',
  'sauvignon-blanc': 'sauvignon blanc',

  // Syrah
  'syrah': 'syrah',
  'syrah-shiraz': 'syrah',

  // Miscellaneous
  'spiked seltzer': 'hard seltzer',
  'sir davis': 'sirdavis',
};
